import type { ApiErrorBody, ApiErrorCode } from "./apiErrorCodes";

// Код ошибки, которого нет в контракте: `http_405` от Ninja, HTML от nginx при 502 и т. п.
export const UNKNOWN_ERROR_CODE = "unknown";

export type ApiErrorInit = {
  status: number;
  // Тело по контракту или `null`, если бэкенд прислал что-то другое.
  body: ApiErrorBody | null;
  // Код как пришёл с бэкенда (для Sentry), `null` — тела `{error}` не было.
  rawCode: string | null;
};

// Ошибка любого ответа API не из 2xx. Её бросает middleware `errors`, поэтому
// `error` в хуках `$api` — всегда `ApiError` (или сетевая ошибка `TypeError`).
// Поле `status` нужно `app/queryClient.ts`: ответы 4xx не повторяются.
export class ApiError extends Error {
  readonly status: number;
  readonly code: ApiErrorCode | typeof UNKNOWN_ERROR_CODE;
  readonly params: Readonly<Record<string, unknown>>;
  readonly body: ApiErrorBody | null;
  readonly rawCode: string | null;

  constructor({ status, body, rawCode }: ApiErrorInit) {
    const code = body?.error ?? UNKNOWN_ERROR_CODE;
    super(`API ${String(status)}: ${rawCode ?? code}`);
    this.name = "ApiError";
    this.status = status;
    this.code = code;
    this.params = body?.params ?? {};
    this.body = body;
    this.rawCode = rawCode;
  }
}
